import type { CommonSVGProps } from './helpers';

export const IconSquareMenu = ({ height = 16, stroke: strokeProp = '1.6', width = 16, ...props }: CommonSVGProps) => {
  const strokeWidth = typeof strokeProp === 'number' ? strokeProp : Number.parseFloat(String(strokeProp)) || 1.6;

  return (
    <svg fill="none" height={height} viewBox="0 0 16 16" width={width} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g transform="translate(0.45 0)">
        <path
          d="M3.80078 4.54999H11.3008M3.80078 7.54999H11.3008M3.80078 10.55H11.3008M2.30078 0.799988H12.8008C13.6292 0.799988 14.3008 1.47156 14.3008 2.29999V12.8C14.3008 13.6284 13.6292 14.3 12.8008 14.3H2.30078C1.47235 14.3 0.800781 13.6284 0.800781 12.8V2.29999C0.800781 1.47156 1.47235 0.799988 2.30078 0.799988Z"
          stroke="#292929"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
      </g>
    </svg>
  );
};
